import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DocumentLinkModalComponent } from './document-link-modal.component';
import { MatListModule } from '@angular/material/list';
import { DocumentLinkFilterDisplayComponent } from '../document-link-filter-display/document-link-filter-display.component';
import { DocumentLinkSelectorModule } from '../document-link-selector/doucment-link-selector.module';
import { DocumentLinkService } from '../document-link.service';

@NgModule({
  declarations: [DocumentLinkModalComponent, DocumentLinkFilterDisplayComponent],
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatListModule, DocumentLinkSelectorModule],
  exports: [DocumentLinkModalComponent],
  providers: [DocumentLinkService]
})
export class DocumentLinkModalModule {}
